var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input-base-date-picker-range',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}},[_c('div',{staticClass:"f-search"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }